window.recipes = [

  {
    title: "Sweet Potato Waffles",

    mealType: ["Breakfast"],

    cook: 45,

    image: "",

    link: "https://www.beneditaforall.com/blogs/recipes/sweet-potato-waffles",

    ingredients: [
      { item: "Sweet Potatoes", amount: 2, unit: "", category: "Produce" },
      { item: "Flour", amount: 1, unit: "cup", category: "Pantry" },
      { item: "Baking Soda", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Salt", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Garlic Powder", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Paprika", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Eggs", amount: 2, unit: "", category: "Poultry" },
      { item: "Milk", amount: 0.5, unit: "cup", category: "Dairy" },
      { item: "Butter", amount: 4, unit: "tbsp", category: "Dairy" },
      { item: "Mozzarella Cheese", amount: 0.5, unit: "cup", category: "Dairy" },
    ]
  },

  {
    title: "Million Dollar Hamburgers",

    mealType: ["Dinner", "Lunch"],

    cook: 60,

    image: "",

    link: "https://www.beneditaforall.com/blogs/recipes/billion-dollar-burgers",

    ingredients: [
      { item: "Ground Beef", amount: 1, unit: "lb", category: "Meat" },
      { item: "Onion", amount: 1/2, unit: "", category: "Produce" },
      { item: "BBQ Sauce", amount: 1, unit: "tbsp", category: "Pantry" },
      { item: "Ceole Seasoning", amount: 2, unit: "tsp", category: "Pantry" },
      { item: "Parsley", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Salt", amount: 1, unit: "tsp", category: "Pantry" },
      { item: "Pepper", amount: 1, unit: "tsp", category: "Pantry" },
      { item: "Baking Soda", amount: 0.5, unit: "tsp", category: "Pantry" },
    ]
  },

  {
    title: "Creamy Beef & Shells",

    mealType: ["Dinner"],

    cook: 30,

    image: "",

    link: "#",

    ingredients: [
      { item: "Pasta Shells", amount: 8, unit: "oz", category: "Grains" },
      { item: "Olive Oil", amount: 1, unit: "tbsp", category: "Pantry" },
      { item: "Onion", amount: 0.5, unit: "", category: "Produce" },
      { item: "Ground Beef", amount: 1, unit: "lb", category: "Meat" },
      { item: "Flour", amount: 2, unit: "tbsp", category: "Pantry" },
      { item: "Garlic Powder", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Italian Seasoning", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Beef Stock", amount: 2, unit: "cups", category: "Liquids" },
      { item: "Tomato Sauce", amount: 15, unit: "oz", category: "Liquids" },
      { item: "Milk", amount: 0.75, unit: "cup", category: "Dairy" },
      { item: "Cheddar Cheese", amount: 6, unit: "oz", category: "Dairy" },
    ]
  },
  {
    title: "Crack Chicken",

    mealType: ["Dinner"],

    cook: 10,

    image: "",

    link: "https://www.beneditaforall.com/blogs/recipes/crock-pot-crack-chicken",

    ingredients: [
      { item: "Chicken Breast", amount: 2, unit: "lbs", category: "Poultry" },
      { item: "Buttermilk", amount: 0.25, unit: "cup", category: "Dairy" },
      { item: "Dried Parsley", amount: 1, unit: "tsp", category: "Pantry" },
      { item: "Garlic Salt", amount: 1, unit: "tsp", category: "Pantry" },
      { item: "Onion Powder", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Dill", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Pepper", amount: 1, unit: "tsp", category: "Pantry" },
      { item: "Cream Cheese", amount: 8, unit: "oz", category: "Dairy" },
      { item: "Bacon", amount: 0.5, unit: "lb", category: "Meat" },
      { item: "Cheddar Cheese", amount: 1, unit: "cup", category: "Dairy" },
      { item: "Green Onions", amount: 3, unit: "", category: "Produce" },
    ]
  },

  {
    title: "Egg Salad",

    mealType: ["Dinner"],

    cook: 25,

    image: "",

    link: "https://www.beneditaforall.com/blogs/recipes/quick-easy-egg-salad",

    ingredients: [
      { item: "Eggs", amount: 8, unit: "", category: "Poultry" },
      { item: "Mayo", amount: 0.75, unit: "cup", category: "Sauces" },
      { item: "Dill", amount: 1, unit: "tsp", category: "Pantry" },
      { item: "Dijon Mustard", amount: 1, unit: "tsp", category: "Sauces" },
      { item: "Onion Powder", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Garlic Powder", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Salt", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Pepper", amount: 0.25, unit: "tsp", category: "Pantry" },
      { item: "Paprika", amount: 0.5, unit: "tsp", category: "Pantry" },

    ]
  },
  {
    title: "Taco Salad",

    mealType: ["Dinner"],

    cook: 30,

    image: "",

    link: "https://www.beneditaforall.com/blogs/recipes/taco-salad-for-a-crowd",

    ingredients: [
      { item: "Ground Beef", amount: 1, unit: "lb", category: "Meat" },
      { item: "Lettuce", amount: 1, unit: "Head", category: "Produce" },
      { item: "Red Kidney Beans", amount: 15, unit: "oz", category: "Vegitables" },
      { item: "Tomates", amount: 2, unit: "", category: "Produce" },
      { item: "Cheddar Cheese", amount: 12, unit: "oz", category: "Dairy" },
      { item: "Catalina Dressing", amount: 8, unit: "oz", category: "Sauces" },
      { item: "Corn Chips", amount: 10, unit: "oz", category: "Other" },
    ]
  },
  {
    title: "Chicken Salad",

    mealType: ["Dinner"],

    cook: 60,

    image: "",

    link: "#",

    ingredients: [
      { item: "Chicken Breast", amount: 2, unit: "lbs", category: "Poultry" },
      { item: "Lemon Pepper", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Celery", amount: 1, unit: "Stalks", category: "Produce" },
      { item: "Chicken Seasoning", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Grapes", amount: 0.25, unit: "lb", category: "Fruit" },
      { item: "Pickle Relish", amount: 0.25, unit: "cup", category: "Other" },
      { item: "Mayo", amount: 0.5, unit: "cup", category: "Sauces" },
      { item: "Pecans", amount: 0.5, unit: "cup", category: "Nuts" },
    ]
  },
  {
    title: "Spagetti Casserole",

    mealType: ["Dinner"],

    cook: 70,

    image: "",

    link: "#",

    ingredients: [
      { item: "Ground Beef", amount: 1.5, unit: "lbs", category: "Meat" },
      { item: "Spagetti", amount: 16, unit: "oz", category: "Grains" },
      { item: "Onion", amount: 1, unit: "", category: "Produce" },
      { item: "Mozarella Cheese", amount: 3, unit: "cups", category: "Dairy" },
      { item: "Cream Cheese", amount: 8, unit: "oz", category: "Dairy" },
      { item: "Marinara Sauce", amount: 28, unit: "oz", category: "Sauces" },
      { item: "Oregano", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Garlic Powder", amount: 1, unit: "tsp", category: "Spices" },

    ]
  },
  {
    title: "Sundried Tomato & Sausage Fettuccini",

    mealType: ["Dinner"],

    cook: 25,

    image: "",

    link: "#",

    ingredients: [
      { item: "Butter", amount: 3, unit: "tbsp", category: "Dairy" },
      { item: "Italian Sausage", amount: 1, unit: "lb", category: "Meat" },
      { item: "Garlic", amount: 3, unit: "cloves", category: "Produce" },
      { item: "Chicken Broth", amount: 2, unit: "cups", category: "Pantry" },
      { item: "Heavy Cream", amount: 0.5, unit: "cup", category: "Dairy" },
      { item: "Sun-Dried Tomatoes", amount: 8, unit: "oz", category: "Other" },
      { item: "Fettuccini Noodles", amount: 8, unit: "oz", category: "Grains" },
      { item: "Cream Cheese", amount: 4, unit: "oz", category: "Dairy" },
      { item: "Italian Seasoning", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Salt", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Pepper", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Red Pepper Flakes", amount: 0.5, unit: "tsp", category: "Spices" },
    ]
  },
  {
    title: "Fettuccini Alfredo with Shrmip",

    mealType: ["Dinner"],

    cook: 30,

    image: "",

    link: "#",

    ingredients: [
      { item: "Fettuccini Noodles", amount: 1, unit: "lb", category: "Grain" },
      { item: "Butter", amount: 6, unit: "tbsp", category: "Dairy" },
      { item: "Garlic", amount: 1, unit: "cloves", category: "Produce" },
      { item: "Heavy Cream", amount: 1.5, unit: "cups", category: "Dairy" },
      { item: "Salt", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Parmesan Cheese", amount: 10, unit: "oz", category: "Dairy" },
      { item: "Pepper", amount: 0.25, unit: "tsp", category: "Spices" },
      { item: "Dried Parsley", amount: 2, unit: "tsp", category: "Spices" },
      { item: "Shrimp", amount: 1, unit: "lb", category: "Seafood" },

    ]
  },
  {
    title: "Fettuccini Alfredo with Chicken",

    mealType: ["Dinner"],

    cook: 30,

    image: "",

    link: "#",

    ingredients: [
      { item: "Fettuccini Noodles", amount: 1, unit: "lb", category: "Grain" },
      { item: "Butter", amount: 6, unit: "tbsp", category: "Dairy" },
      { item: "Garlic", amount: 1, unit: "cloves", category: "Produce" },
      { item: "Heavy Cream", amount: 1.5, unit: "cups", category: "Dairy" },
      { item: "Salt", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Parmesan Cheese", amount: 10, unit: "oz", category: "Dairy" },
      { item: "Pepper", amount: 0.25, unit: "tsp", category: "Spices" },
      { item: "Dried Parsley", amount: 2, unit: "tsp", category: "Spices" },
      { item: "Chicken", amount: 1, unit: "lb", category: "Poultry" },

    ]
  },
  {
    title: "Fettuccini Alfredo with Sausage",

    mealType: ["Dinner"],

    cook: 30,

    image: "",

    link: "#",

    ingredients: [
      { item: "Fettuccini Noodles", amount: 1, unit: "lb", category: "Grain" },
      { item: "Butter", amount: 6, unit: "tbsp", category: "Dairy" },
      { item: "Garlic", amount: 1, unit: "cloves", category: "Produce" },
      { item: "Heavy Cream", amount: 1.5, unit: "cups", category: "Dairy" },
      { item: "Salt", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Parmesan Cheese", amount: 10, unit: "oz", category: "Dairy" },
      { item: "Pepper", amount: 0.25, unit: "tsp", category: "Spices" },
      { item: "Dried Parsley", amount: 2, unit: "tsp", category: "Spices" },
      { item: "Italian Sausage", amount: 1, unit: "lb", category: "Meat" },

    ]
  },
  {
    title: "Oven Baked Salmon",

    mealType: ["Dinner"],

    cook: 30,

    image: "",

    link: "#",

    ingredients: [
      { item: "Salmon Filets", amount: 2, unit: "", category: "Seafood" },
      { item: "Butter", amount: 3, unit: "tbsp", category: "Dairy" },
      { item: "Garlic", amount: 2, unit: "cloves", category: "Produce" },
      { item: "Brown Sugar", amount: 2, unit: "tbsp", category: "Pantry" },
      { item: "Paprika", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Garlic Powder", amount: 8, unit: "oz", category: "Other" },
      { item: "Italian Seasoning", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Salt", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Pepper", amount: 0.5, unit: "tsp", category: "Spices" },

    ]
  },
  {
    title: "Shrimp & Manjo Stir Fry",

    mealType: ["Dinner"],

    cook: 30,

    image: "",

    link: "#",

    ingredients: [
      { item: "Rice", amount: 1, unit: "cup", category: "Grains" },
      { item: "Chicken Stock", amount: 1, unit: "cup", category: "Other" },
      { item: "Salt", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Shrimp", amount: 1, unit: "lb", category: "Seafood" },
      { item: "Honey", amount: 3, unit: "tbsp", category: "Sauces" },
      { item: "Tomatoes", amount: 2, unit: "", category: "Produce" },
      { item: "Corn", amount: 15, unit: "oz", category: "Vegitables" },
      { item: "Mangos", amount: 2, unit: "", category: "Fruit" },
      { item: "Avocado", amount: 1, unit: "", category: "Fruit" },

    ]
  },
  {
    title: "Corn Chowder",

    mealType: ["Dinner"],

    cook: 60,

    image: "",

    link: "#",

    ingredients: [
      { item: "Bacon", amount: 7.5, unit: "oz", category: "Meat" },
      { item: "Corn", amount: 32, unit: "oz", category: "Vegitables" },
      { item: "Butter", amount: 2, unit: "tbsp", category: "Dairy" },
      { item: "Garlic", amount: 3, unit: "cloves", category: "Produce" },
      { item: "Onion", amount: 1, unit: "", category: "Produce" },
      { item: "Carrots", amount: 3, unit: "", category: "Produce" },
      { item: "Flour", amount: 0.25, unit: "cup", category: "Pantry" },
      { item: "Italian Seasoning", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Thyme", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Potatoes", amount: 3, unit: "", category: "Vegitables" },
      { item: "Chicken Broth", amount: 2, unit: "cups", category: "Other" },
      { item: "Milk", amount: 3, unit: "cups", category: "Dairy" },
      { item: "Bay Leaf", amount: 1, unit: "", category: "Spices" },
      { item: "Heavy Cream", amount: 0.5, unit: "cups", category: "Dairy" },
      { item: "Salt", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Pepper", amount: 1, unit: "tsp", category: "Spices" },
    ]
  },
  {
    title: "Potato Soup",

    mealType: ["Dinner"],

    cook: 60,

    image: "",

    link: "#",

    ingredients: [
      { item: "Italian Sausage", amount: 1, unit: "lb", category: "Meat" },
      { item: "Butter", amount: 5, unit: "tbsp", category: "Dairy" },
      { item: "Carrots", amount: 1, unit: "", category: "Vegitables" },
      { item: "Onion", amount: 0.5, unit: "", category: "Produce" },
      { item: "Garlic", amount: 2, unit: "cloves", category: "Produce" },
      { item: "Potatoes", amount: 4, unit: "", category: "Vegitables" },
      { item: "Dried Parsley", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Dried Basil", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Chicken Stock", amount: 4, unit: "cups", category: "Other" },
      { item: "Flour", amount: 6, unit: "tbsp", category: "Pantry" },
      { item: "Milk", amount: 3, unit: "cups", category: "Dairy" },
      { item: "Heavy Cream", amount: 0.5, unit: "cups", category: "Dairy" },
      { item: "Salt", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Pepper", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Cheddar Cheese", amount: 2, unit: "cups", category: "Dairy" },
      { item: "Sour Cream", amount: 0.25, unit: "cup", category: "Dairy" },
    ]
  },
  {
    title: "Chicken & Dumplings",

    mealType: ["Dinner"],

    cook: 60,

    image: "",

    link: "https://www.beneditaforall.com/blogs/recipes/homestyle-chicken-dumpling-soup",

    ingredients: [
      { item: "Flour", amount: 2, unit: "cups", category: "Pantry" },
      { item: "Baking Powder", amount: 0.5, unit: "tsp", category: "Pantry" },
      { item: "Butter", amount: 1, unit: "tbsp", category: "Dairy" },
      { item: "Milk", amount: 1, unit: "cup", category: "Dairy" },
      { item: "Chicken Broth", amount: 8, unit: "cups", category: "Other" },
      { item: "Onion Powder", amount: 1.25, unit: "tsp", category: "Spices" },
      { item: "Garlic Powder", amount: 1.25, unit: "tsp", category: "Spices" },
      { item: "Poultry Seasoning", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Creole Seasoning", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Salt", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Pepper", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Chicken", amount: 1.5, unit: "lbs", category: "Poultry" },

    ]
  },
  {
    title: "White Bean & Ham Soup",

    mealType: ["Dinner"],

    cook: 60,

    image: "",

    link: "#",

    ingredients: [
      { item: "Butter", amount: 2, unit: "tbsp", category: "Dairy" },
      { item: "Onion", amount: 1, unit: "", category: "Produce" },
      { item: "Carrots", amount: 2, unit: "", category: "Vegitables" },
      { item: "Celery", amount: 1, unit: "cup", category: "Vegitables" },
      { item: "Garlic", amount: 2, unit: "cloves", category: "Produce" },
      { item: "Bay Leaf", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Thyme", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Paprika", amount: 0.5, unit: "tsp", category: "Spices" },
      { item: "Ham", amount: 1, unit: "lb", category: "Meat" },
      { item: "White Beans", amount: 15, unit: "oz", category: "Grains" },
      { item: "Pepper", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Salt", amount: 1, unit: "tsp", category: "Spices" },
      { item: "Dried Parsley", amount: 0.5, unit: "tsp", category: "Spices" },

    ]
  },
  {
    title: "Crispy Rice Salad",

    mealType: ["Lunch, Dinner"],

    cook: 45,

    image: "",

    link: "https://christinabassrossetti.substack.com/p/crispy-rice-chicken-salad-with-creamy?r=8y53is&utm_medium=ios",

    ingredients: [
      { item: "Jasmine Rice", amount: 2, unit: "cups", category: "Pantry" },
      { item: "Chili Garlic Sauce", amount: 1, unit: "tbsps", category: "Pantry" },
      { item: "Sesame Oil", amount: 1, unit: "tsps", category: "Pantry" },
      { item: "Soy Sauce", amount: 5, unit: "tbsps", category: "Pantry" },
      { item: "Oil", amount: 2, unit: "tbsps", category: "Pantry" },
      { item: "Chicken Thighs", amount: 1, unit: "lbs", category: "Poultry" },
      { item: "Fresh Ginger", amount: 2, unit: "inches", category: "Produce" },
      { item: "Paprika", amount: 1/2, unit: "tsps", category: "Pantry" },
      { item: "Peanut Butter", amount: 2, unit: "tbsps", category: "Pantry" },
      { item: "Lime", amount: 1, unit: "", category: "Produce" },
      { item: "Milk", amount: 1/4, unit: "cups", category: "Dairy" },
      { item: "Garlic", amount: 1, unit: "cloves", category: "Produce" },
      { item: "Mixed Greens", amount: 4, unit: "cups", category: "Produce" },
      { item: "Cucumber", amount: 1, unit: "", category: "Produce" },
      { item: "Carrots", amount: 1, unit: "", category: "Produce" },
      { item: "Green Onions", amount: 3, unit: "", category: "Produce" },
      { item: "Fresh Mint", amount: 1/2, unit: "cups", category: "Produce" },
      { item: "Edamame", amount: 1/2, unit: "cups", category: "Produce" },
      { item: "Peanuts", amount: 1/3, unit: "cups", category: "Pantry" },
    ]
  },
  {
    title: "Lemon Glazed Chicken Thighs",

    mealType: ["Dinner"],

    cook: 30,

    image: "",

    link: "https://tiffycooks.com/honey-lemon-glazed-chicken-thigh/",

    ingredients: [
      { item: "Chicken Thighs", amount: 1, unit: "lbs", category: "Poultry" },
      { item: "Soy Sauce", amount: 2, unit: "tbsp", category: "Pantry" },
      { item: "Garlic Powder", amount: 1, unit: "tsp", category: "Pantry" },
      { item: "Cornstarch", amount: 3, unit: "tbsp", category: "Pantry" },
      { item: "Lemons", amount: 1, unit: "", category: "Produce" },
      { item: "Honey", amount: 2, unit: "tbsp", category: "Pantry" },
    ]
  },
  {
    title: "Chicken Alfredo Smothered Potatos",

    mealType: ["Dinner"],

    cook: 65,

    image: "",

    link: "https://badbatchbaking.com/chicken-alfredo-stuffed-potato/#wprm-recipe-container-22154",

    ingredients: [
      { item: "Russet Potatoes", amount: 4, unit: "", category: "Produce" },
      { item: "Chicken Breasts", amount: 1, unit: "lbs", category: "Poultry" },
      { item: "Butter", amount: 6, unit: "tbsp", category: "Dairy" },
      { item: "Italian Seasoning", amount: 1, unit: "tbsp", category: "Pantry" },
      { item: "Fresh Parsley", amount: 2, unit: "tbsp", category: "Produce" },
      { item: "Garlic", amount: 6, unit: "cloves", category: "Produce" },
      { item: "Heavy Cream", amount: 2, unit: "cups", category: "Dairy" },
      { item: "Parmesan Cheese", amount: 1.5, unit: "cups", category: "Dairy" },
    ]
  },
];
